import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
const IndividualsAffectedField = forwardRef(
  (
    {
      formData,
      handleChange,
      individualsList,
      setIndividualsList,
      setSelectedIndividual,
      highlighted = false,
      type = "",
      bodyPartsData = [],
      setBodyPartsData = () => {},
    },
    ref,
  ) => {
    const textFieldRef = useRef();
    const [expandedIndex, setExpandedIndex] = useState(0);
    useImperativeHandle(ref, () => ({
      scrollToField: () => {
        textFieldRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      },
    }));

    useEffect(() => {
      if (
        Array.isArray(formData.individuals) &&
        formData.individuals.length > 0
      ) {
        const individuals = formData.individuals.map(
          (individual) => individual.name,
        );
        setIndividualsList(individuals);
        formData.individualsList = individuals;
      }
    }, [formData, formData.individuals, setIndividualsList]);

    const handleToggleExpand = (index) => {
      setExpandedIndex((prevIndex) =>
        prevIndex === index ? prevIndex : index,
      ); // Toggle or collapse
    };

    const handleAddIndividual = () => {
      if (formData.individualsAffected.trim()) {
        setIndividualsList([
          ...individualsList,
          formData.individualsAffected.trim(),
        ]);
        formData.individualsList = [
          ...individualsList,
          formData.individualsAffected.trim(),
        ];
        if (formData.individualsList.length === 1) {
          setSelectedIndividual(formData.individualsList[0], 0);
        }
        formData.individualsAffected = "";
      }
    };

    const handleRemoveIndividual = (index) => {
      const updatedList = individualsList.filter((_, i) => i !== index);
      formData.individualsList = updatedList;
      setIndividualsList(updatedList);
      if (type === "Accident") {
        const updatedBody = bodyPartsData.filter((data) => data.id !== index);
        formData.bodyPartsData = updatedBody;
        setBodyPartsData(updatedBody);
      }
    };

    const handleSelectedIndividual = (individual, index) => {
      if (expandedIndex === index) {
        handleToggleExpand(null);
        setSelectedIndividual(null, null);
      } else {
        handleToggleExpand(index);
        setSelectedIndividual(individual, index);
      }
    };
    return (
      <div style={{ marginBottom: 0 }}>
        <TextField
          fullWidth
          margin="normal"
          name="individualsAffected"
          label="Individual Affected"
          value={
            Array.isArray(formData.individualsAffected)
              ? ""
              : formData.individualsAffected
          }
          onChange={handleChange}
          sx={{ border: highlighted ? "2px solid #1976d2" : "none" }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleAddIndividual}>
                  <AddIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          inputRef={textFieldRef}
        />

        <List sx={{ padding: 0 }}>
          {individualsList.map((individual, index) => (
            <ListItem
              key={index}
              button
              onClick={() => handleSelectedIndividual(individual, index)}
              sx={{
                backgroundColor:
                  expandedIndex === index ? "lightblue" : "white",
                cursor: "pointer",
                border: expandedIndex === index ? "2px solid #007BFF" : "none",
                "&:hover": {
                  backgroundColor:
                    expandedIndex === index ? "lightblue" : "#f5f5f5",
                },
              }}
            >
              <ListItemText
                primary={`${individual} ${
                  type === "Accident"
                    ? `(${Object.keys(bodyPartsData.find((data) => data.id === index)?.bodyParts || []).length})`
                    : ""
                }
                `}
              />
              {type === "Accident" && (
                <IconButton sx={{ marginLeft: "auto" }}>
                  {expandedIndex === index ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              )}

              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  onClick={() => handleRemoveIndividual(index)}
                >
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </div>
    );
  },
);

export default IndividualsAffectedField;
